import { type ArticleCardProps } from '3-components/ArticleCard/ArticleCard';
import { resolveAssetPagesToArticleCards, type AssetPageItems, type AssetPage } from './articleCardResolver';
import { type AssetsListingQuery } from 'cms/cms';
import { resolveAssetPagesToMapItems } from './mapItemResolver';
import { type MapItem } from '4-sections/AssetsListing/Map/ListingMap';
import { resolveAssetsPagesToLocationCardGroups, type RegionName, type AssetsCardGroup } from './assetCardGroupResolver';


interface AssetListingData {
    total: number;
    cardGroups: AssetsCardGroup[];
    cardItems: ArticleCardProps[];
    mapItems: MapItem[];
}

export const resolveAssetListing = (data: AssetsListingQuery): AssetListingData | null => {
    const { items, total, facets } = data.AssetPage as AssetPage;

    const regionNames = facets?.RegionCategories?.Name || [];
    const regionDescriptions = facets?.RegionCategories?.Description || [];
    const combinedRegions = regionNames.map((nameObj, index) => {
        return {
            ...nameObj,
            description: regionDescriptions?.[index]?.name || nameObj?.name,
        };
    });

    return {
        total: Number(total),
        cardGroups: resolveAssetsPagesToLocationCardGroups(items as AssetPageItems, combinedRegions as RegionName[]),
        cardItems: resolveAssetPagesToArticleCards(items as AssetPageItems),
        mapItems: resolveAssetPagesToMapItems(items as AssetPageItems),
    };
};
